import React from "react";
import {
    Box,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Button,
    DialogActions
} from "@mui/material";
import { BsFiletypePdf } from "react-icons/bs";
import { Chip, Table, Tooltip } from "@mui/joy";
import { useUser } from "../../config/UserContext";
import { PolicyPdfReport } from "../ReportGenerationComponents/PolicyPdfReport";


export default function UserPolicyHistory({ open, onClose, policyData = {}, history = [] }) {

    const { userData, roleDetail, homeDetail, trainingProviders } = useUser();
    
    const handleDownloadPDF = async () => {
        let userDetails = userData;
        userDetails["homeName"] = homeDetail.homeName;
        userDetails["roleName"] = roleDetail.roleName;
        const historyToDownload = history.map(pol => {
            return { ...pol, title: policyData.title };
        });
        await PolicyPdfReport(userDetails, historyToDownload, [], trainingProviders, 'Home Doc History', 'Carepassport_HomeDocHistory_' + policyData.policyId + "_" + userDetails?.user_id, false, 3);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                disableScrollLock={true}
                PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
            >
                <DialogTitle variant="body1">Home Doc History</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" gutterBottom>
                            </Typography>

                            <Box sx={{ mt: 2 }}>
                                {[
                                    { label: "Title", value: policyData.title },
                                    { label: "Type", value: policyData.type },
                                    { label: "Description", value: policyData.description },
                                    { label: "User ID", value: userData?.user_id },
                                    { label: "Home ", value: homeDetail?.homeName },
                                    { label: "Role ", value: roleDetail?.roleName },

                                ].map((field, index) => (
                                    <Box
                                        key={field.label}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'start',
                                            mb: 2,
                                            "&:last-child": { mb: 0 }
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            color="primary"
                                            sx={{
                                                minWidth: '120px',
                                                pt: 0.5
                                            }}
                                        >
                                            {field.label}:
                                        </Typography>
                                        <Typography variant="body2">
                                            {field.value || "N/A"}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                        </Grid>

                        <Grid item xs={12} md={8}>

                            <Typography variant="h6">
                                History
                                {policyData.url && (
                                    <Tooltip title="Download Home Doc History">
                                        <IconButton
                                            color="primary"
                                            onClick={handleDownloadPDF}
                                            title="Download Home Doc History"
                                        >
                                            <BsFiletypePdf />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Typography>
                            <Box sx={{ mt: 2 }}>

                                <Table
                                    borderAxis="bothBetween"
                                    stripe="odd"
                                    hoverRow
                                    sx={{ minWidth: 700 }}
                                >
                                    <thead>
                                        <tr>
                                            <th>Doc Code</th>
                                            <th>Version</th>
                                            <th>Date</th>
                                            <th>Expiry Date</th>
                                            {/* <th>Reason</th> */}
                                            <th>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(history.length > 0) ?
                                            history.map((row) => (
                                                <tr key={row._id}>
                                                    <td>{row.policyId}</td>
                                                    <td>{row.policyNumber}</td>
                                                    <td>
                                                        {new Date(row.completion_date).toLocaleDateString()}
                                                    </td>
                                                    <td>
                                                        {(row.expiry_date != "") ? new Date(row.expiry_date).toLocaleDateString() : "N/A"}
                                                    </td>
                                                    {/* <td>
                                                        {(row.expiry_reason !== "") ? row.expiry_reason : "N/A"}
                                                    </td> */}
                                                    <td>
                                                        <Chip
                                                            color={row.verification === "Validated" ? "success" : (row.verification === "Assigned") ? "primary" : "warning"}
                                                            variant="soft"
                                                            size="sm"
                                                        >
                                                            {row.verification}
                                                        </Chip>
                                                    </td>

                                                </tr>
                                            ))
                                            : <td colSpan={5} style={{ "text-align": "center" }}>No history available</td>
                                        }
                                    </tbody>
                                </Table>
                            </Box>

                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>

        </>
    );
}
